import { lazy } from 'react';
import { t } from 'i18next';
import { Navigate } from 'react-router-dom';

import { CompanyInfoScreen, DashboardAnalyzeDocuments, EnquiryScreen } from '../pages/DashboardCustomer';
import { BillingScreen } from '../pages/DashboardCustomer/BillingScreen';
import { DashboardRegistering } from '../pages/DashboardCustomer/Registering/DashboardRegistering';
import { PreferencesScreen } from '../pages/DashboardCustomer/Preferences';
import { RequestScreen } from '../pages/DashboardCustomer/RequestScreen';
import DashboardDirectorsPreferences from '../pages/DashboardCustomer/DashboardDirectorsPreferences';
import { OnboardingOffshore } from '../pages/DashboardCustomer/OnboardingOffshore';
import { CompanyTransferOffshore } from '../pages/DashboardCustomer/OnboardingOffshore/CompanyTransfer';
import { ChooseOffshoreType } from '../pages/DashboardCustomer/ChooseOffshoreType';
import { AnnualRenewalOnboarding } from '../pages/DashboardCustomer/OnboardingOffshore/AnnualRenewalOnboarding/index';
import { ComingSoonScreen } from '../pages/ComingSoon/ComingSoonScreen';

const DashboardHomeUsers = lazy(() => import('../pages/DashboardCustomer/DashboardHomeUsers'));


const costumerRoutes = [
  {
    path: '',
    name: t('others.othDashboard'),
    component: <DashboardHomeUsers />
  },
  {
    path: 'view-documents',
    name: t('labels.lblAnalyzeDocuments'),
    component: <DashboardAnalyzeDocuments />
  },
  {
    path: 'directors-preferences',
    name: 'Directors Preferences',
    component: <DashboardDirectorsPreferences />
  },
  {
    path: 'companyInfo',
    name: t('labels.lblCompanyInfo'),
    component: <CompanyInfoScreen />
  },
  {
    path: 'incorporation-status',
    name: t('labels.lblCompanyDetails'),
    component: <Navigate to="/dashboard/companyInfo" replace />
  },
  {
    path: 'registering',
    name: 'Registering Company',
    component: <DashboardRegistering />
  },
  {
    path: 'accounting',
    name: t('labels.lblAccounting'),
    component: <ComingSoonScreen titleKey="labels.lblAccounting" />
  },
  {
    path: 'request',
    name: t('labels.lblRequestsBar'),
    component: <RequestScreen />
  },
  {
    path: 'billing',
    name: 'Billing',
    component: <BillingScreen />
  },
  {
    path: 'enquiry',
    name: t('labels.lblEnquiry'),
    component: <EnquiryScreen />
  },
  {
    path: 'preferences',
    name: t('labels.lblPrefereces'),
    component: <PreferencesScreen />
  },
  {
    path: 'choose-offshore-type',
    name: 'choose-offshore-type',
    component: <ChooseOffshoreType />
  },
  {
    path: 'create-offshore',
    name: 'create-offshore',
    component: <OnboardingOffshore />
  },
  {
    path: 'company-transfer',
    name: 'company-transfer',
    component: <CompanyTransferOffshore />
  },
  {
    path: 'annual-renewal',
    name: 'annual-renewal',
    component: <AnnualRenewalOnboarding />
  }
];

export { costumerRoutes };
